import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { getCleanHTML } from 'shared/lib/getCleanHTML'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

type Props = {
  currentExcursion: IExcursionDetails
}

export const TimeAndPlaceInfo = ({ currentExcursion }: Props) => {
  const { t } = useTranslation()
  return (
    <Paper>
      <div className={s.timeAndPlace}>
        <h4 className={s.timeAndPlaceTitle}>
          {t('excursions.time_and_place')}
        </h4>
        <div
          className={clsx(s.timeAndPlaceDescription, 'regular-14')}
          dangerouslySetInnerHTML={{
            __html: getCleanHTML(currentExcursion?.gathering_info),
          }}
        />
      </div>
    </Paper>
  )
}
